<template>
  <div class="location-map">
    <LMap
      :zoom="12"
      :center="[lat, lng]"
      height="120px"
      :options="opts"
      @click="click">
      <LMapboxGL
        :url="tiles"
        attribution="<a href='https://www.maptiler.com/copyright/' target='_blank' rel='noopener'>© MapTiler</a> <a href='https://www.openstreetmap.org/copyright' target='_blank' rel='noopener'>© OSM</a>" />
      <LMarker
        ref="marker"
        :latlng="[lat, lng]">
        <LAwesomeMarker
          :options="{
            icon: 'circle',
            markerColor: 'blue',
            prefix: 'fa'
          }" />
      </LMarker>
    </LMap>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { tilesStyles } from '@/services/maptiler'
export default {
  name: 'LocationMap',
  props: {
    lat: {
      type: Number,
      required: true
    },
    lng: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      opts: {
        zoomControl: false,
        dragging: false,
        doubleClickZoom: false,
        boxZoom: false,
        scrollWheelZoom: false
      },
      address: ''
    }
  },
  computed: {
    tiles () { return tilesStyles(this.setting('tiles')) }
  },
  methods: {
    ...mapActions({
      setSetting: 'global/setSetting',
      setFlyTo: 'global/setFlyTo'
    }),
    click (e) {
      this.$f7.views.main.router.navigate('/')
      this.$nextTick(() => {
        this.setFlyTo([this.lat, this.lng], 18)
      })
      this.$emit('click', e)
    }
  }
}
</script>

<style lang="scss">
.location-map {
  .leaflet-container {
    border-radius: 8px;
  }
}
</style>
